const Font = name => {
  switch (name) {
    case '4xl':
      return 'font-size: 36px';
    
    case '3xl':
      return 'font-size: 24px';
    
    case '2xl':
      return 'font-size: 20px';
    
    case 'xl':
      return 'font-size: 18px';
    
    case 'lg':
      return 'font-size: 15px';      
    
    case 'md':
      return 'font-size: 14px';
    
    case 'base':
      return 'font-size: 13px';
    
    case 'sm':
      return 'font-size: 12px';
    
    case 'xs':
      return 'font-size: 11px';
  
    default:  // font-base
      return 'font-size: 13px';
  }
}

export default Font;


// WEBPACK FOOTER //
// ./client/components/Styled/Button/Font.js